import { useTranslation } from "react-i18next";
import { BiBlock } from "react-icons/bi";
import { useParams } from "react-router-dom";
import logo from "shared/assets/images/logo.svg";
import { NAME_SPACES } from "shared/locales/constants";
import { SOURCE_AVAILABILITY } from "./sourceAvailability";

const Unavailable = () => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const { status } = useParams();
  const reason =
    status === SOURCE_AVAILABILITY.NOT_STARTED
      ? SOURCE_AVAILABILITY.NOT_STARTED
      : SOURCE_AVAILABILITY.CLOSED;

  return (
    <div className="onboarding">
      <header className="onboarding__header">
        <div className="onboarding__header-inner onboarding__header-inner--plain">
          <img src={logo} alt="" className="onboarding__brand" />
        </div>
      </header>
      <div className="onboarding__body onboarding__body--single">
        <section className="onboarding__main">
          <p className="onboarding__notice onboarding__notice--warning">
            <BiBlock size={18} aria-hidden="true" />
            <span>{t(`UNAVAILABLE.${reason}`)}</span>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Unavailable;
